import React, { Component } from 'react';
import { withNamespaces } from 'react-i18next';

class SuperAdminFooterComponent extends Component {
    constructor(props) {

        super(props);
    }
    render() {
        const { t } = this.props;
        var currentYear = new Date().getFullYear()
        return (
            <div className="footer">
                <p>{currentYear} <a>{t('footer.All Rights Reserved')} </a>
                </p>
            </div>
        );
    }
}

export default withNamespaces()(SuperAdminFooterComponent);